import { useEffect, useState } from 'react'

/** How long "Joining the meeting…" may stand before the meeting is shown anyway. */
export const JOINING_OVERLAY_MAX_MS = 12_000

/**
 * Whether to cover the stage with "Joining the meeting…".
 *
 * Shown from entering a room until its participant list arrives (`rosterReady`,
 * usePresence) — that list is sent even when you are the only one there, so it
 * ends the wait in an empty meeting too. Never longer than
 * JOINING_OVERLAY_MAX_MS: past that the meeting is shown as it stands, and the
 * Reconnecting banner speaks for a connection that is the problem. Gone the
 * moment there is no room, so leaving never shows it.
 */
export function useJoiningOverlay(
  rosterReady: boolean,
  roomKey: string | null,
  maxMs: number = JOINING_OVERLAY_MAX_MS,
): boolean {
  const [timedOutRoom, setTimedOutRoom] = useState<string | null>(null)

  useEffect(() => {
    if (!roomKey || rosterReady) return
    const id = setTimeout(() => setTimedOutRoom(roomKey), maxMs)
    return () => clearTimeout(id)
  }, [roomKey, rosterReady, maxMs])

  return !!roomKey && !rosterReady && timedOutRoom !== roomKey
}
